import React from "react";
import { ISiteMap } from "../root/PageManager";

const SiteMapContext = React.createContext<ISiteMap | null>(null);

export default SiteMapContext;
